<ng-template #defaultTemplate [lgChartTemplateContextType]="this" let-context>
    <div>
        <table class="lg-chart__tooltip__table">
            <tr class="lg-chart__tooltip__table__item">
                <td class="lg-chart__tooltip__table__item__name_column lg-d3-tooltip__tip-name">
                    {{ ".Tooltip_group_title" | lgTranslate }}
                </td>
                <td class="lg-chart__tooltip__table__item__color_column lg-d3-tooltip__tip-name">
                    {{ ".Tooltip_x_value_title" | lgTranslate }}
                </td>
                <td class="lg-chart__tooltip__table__item__color_column lg-d3-tooltip__tip-name">
                    {{ ".Tooltip_y_value_title" | lgTranslate }}
                </td>
                <td class="lg-chart__tooltip__table__item__color_column lg-d3-tooltip__tip-name">
                    {{ ".Tooltip_bubble_size_title" | lgTranslate }}
                </td>
            </tr>
            @for (item of context.displayingItems; track item.datum) {
                <tr class="lg-chart__tooltip__table__item">
                    <td class="lg-chart__tooltip__table__item__name_column">
                        {{ groupNameFn(item.datum) }}
                    </td>
                    <td class="lg-chart__tooltip__table__item__name_column">
                        {{ _tooltipFormatterXAxis.format(item.datum.xValue) }}
                    </td>
                    <td class="lg-chart__tooltip__table__item__name_column">
                        {{ _tooltipFormatterYAxis.format(item.datum.yValue) }}
                    </td>
                    <td class="lg-chart__tooltip__table__item__name_column">
                        {{ _tooltipFormatterYAxis.format(item.datum.size) }}
                    </td>
                </tr>
            }
        </table>
    </div>
</ng-template>

<div [style.height.px]="height" [style.width.px]="width">
    <div
        #chartWithLegend
        class="lg-bubble-chart__wrapper"
        [class.lg-bubble-chart__wrapper--flex-row]="legendOptions.position === 'right'"
        [class.lg-bubble-chart__wrapper--flex-column]="legendOptions.position === 'bottom'"
        [style.height.%]="100"
        [style.width.%]="100"
    >
        <div
            #chart
            [style.height.px]="legendOptions.visible ? _svgHeight + _margin.top! : _svgHeight"
            [style.marginTop.px]="_margin.top"
            [style.marginLeft.px]="_margin.left"
        ></div>

        @if (legendOptions.visible) {
            <lg-chart-legend
                [className]="legendOptions.className"
                [definition]="_legendDefinition"
                [position]="legendOptions.position"
                [cropLongNames]="!!legendOptions.cropLongNames"
                [wrapMultilineDefinition]="!!legendOptions.wrapMultilineDefinition"
                [style.paddingBottom.px]="_legendPaddingBottom"
                [width]="_legendWidth ?? 0"
                (onClick)="_onLegendItemClick($event)"
            >
            </lg-chart-legend>
        }
    </div>
</div>
